import { Flex, IconButton, Image, Stack, type StackProps, StackSeparator } from '@chakra-ui/react';
import { Link } from 'react-router';
import { LuChevronsLeft, LuChevronsRight } from 'react-icons/lu';
import StageBookLogo from '@/assets/stagebook_logo.webp';

import SidebarLink from './SidebarLink';
import UserProfile from './UserProfile';
import Logout from './Logout';
import { MENU_LIST } from '../utils/menuList';
import { SIDEBAR_WIDTH, SIDEBAR_COLLAPSED_WIDTH } from '../utils/sizes';

type Props = StackProps & {
  onClose?: () => void;
  isCollapsed?: boolean;
  onToggle?: () => void;
};

const Sidebar = ({ isCollapsed = false, onToggle, onClose, ...props }: Props) => (
  <Stack
    width={{ base: 'xs', md: isCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH }}
    maxW={{ base: 'xs', md: isCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH }}
    height="100vh"
    position={{ base: 'auto', md: 'fixed' }}
    flex="1"
    p={{ base: '4', md: isCollapsed ? '3' : '6' }}
    justifyContent="space-between"
    bg="white"
    overflow="hidden"
    transition="width 0.2s ease, max-width 0.2s ease, padding 0.2s ease"
    {...props}
  >
    <Stack gap="6">
      <Flex
        justifyContent={isCollapsed ? 'center' : 'space-between'}
        alignItems="center"
      >
        {!isCollapsed && (
          <Link to="/painel/agendas">
            <Image src={StageBookLogo} alt="StageBook Logo" width={140} />
          </Link>
        )}
        <IconButton
          aria-label={isCollapsed ? 'Expandir menu' : 'Recolher menu'}
          variant="ghost"
          size="sm"
          color="fg.muted"
          _hover={{ bg: 'primary.50', color: 'primary.500' }}
          onClick={onToggle}
          display={{ base: 'none', md: 'flex' }}
        >
          {isCollapsed ? <LuChevronsRight /> : <LuChevronsLeft />}
        </IconButton>
      </Flex>

      <Stack gap="1">
        {MENU_LIST.map((item) => (
          <SidebarLink
            key={item.label}
            path={item.path}
            icon={item.icon}
            label={item.label}
            isCollapsed={isCollapsed}
            onClose={onClose}
          />
        ))}
      </Stack>
    </Stack>

    <Stack gap="4" separator={<StackSeparator />}>
      <UserProfile isCollapsed={isCollapsed} />
      <Logout isCollapsed={isCollapsed} />
    </Stack>
  </Stack>
);

export default Sidebar;
